import { CiCircleCheck } from "react-icons/ci";
import ModalWrapper from '../ModalWrapper';


export default function SuccessModal({ onClose, message }) {

    return (
        <ModalWrapper onClose={onClose} showClose={false}>
            <div className="p-6 flex flex-col items-center justify-center gap-3">
                <div onClick={onClose} className='w-[120px] aspect-square rounded-full flex items-center justify-center bg-[rgba(52,168,83,0.05)]'>
                    <CiCircleCheck size={75} color="#34A853" />
                </div>

                <p className="text-xl text-white font-semibold">{message}</p>
            </div>
        </ModalWrapper>
    );
}